import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth';
import user from './modules/user';
import settings from './modules/settings';


Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    auth,
    user,
    settings,
  },
  strict: debug,
});


// export default new Vuex.Store({
//   state: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })
